import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CobraDocuments = _resolveComponent("CobraDocuments")!
  const _component_GroupInsuranceDocuments = _resolveComponent("GroupInsuranceDocuments")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.enrollmentType === 0)
      ? (_openBlock(), _createBlock(_component_CobraDocuments, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.enrollmentType === 1)
      ? (_openBlock(), _createBlock(_component_GroupInsuranceDocuments, { key: 1 }))
      : _createCommentVNode("", true)
  ], 64))
}